// PainelChamados.js (Otimizado: Consultas Separadas e Limitadas)

import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    collection,
    onSnapshot,
    orderBy,
    query,
    doc,
    updateDoc,
    serverTimestamp,
    limit
} from './firestore-compat';
import { db, auth, getCollectionName } from "./firebase";
import { createPortal } from "react-dom";

// Componente de chat mudou? Verifique se o caminho está correto
import ChatWindow from "./ChatWindow";

// Lista de técnicos (Poderia vir de uma collection 'configs' no futuro)
const TECNICOS = ["Sem Responsável", "Ubiratan", "Alexandre"];

/* ==============================
     FUNÇÕES AUXILIARES
============================== */
function formatDate(value) {
    if (!value) return "-";
    try {
        const date =
            typeof value.toDate === "function" ? value.toDate() : new Date(value);
        if (isNaN(date.getTime())) return "-";
        return date.toLocaleDateString("pt-BR") + " " + date.toLocaleTimeString("pt-BR", { hour: '2-digit', minute: '2-digit' });
    } catch {
        return "-";
    }
}

const getStatusClass = (status) => {
    if (!status) return '';
    return `status-${status.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s/g, '-')}`;
};

const getPriorityClass = (priority) => {
    if (!priority) return '';
    return `prio-${priority.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s/g, '')}`;
};


/* =====================================================
            POPUP DE DETALHES
===================================================== */
function PopupDetalhes({ chamado, onClose, alterarResponsavel, alterarStatus, alterarUrgencia }) {
    if (!chamado) return null;

    return createPortal(
        <div className="popup-overlay">
            <div className="popup-content" style={{ maxWidth: '700px', width: '90%' }}>

                <button className="popup-close" onClick={onClose}>X</button>

                <h2>Detalhes do Chamado #{chamado.idPublico}</h2>

                {/* INFO GERAL EM GRID */}
                <div className="popup-grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
                    <div className="popup-section">
                        <strong>Título:</strong> <span>{chamado.title}</span>
                    </div>
                    <div className="popup-section">
                        <strong>Categoria:</strong> <span>{chamado.category}</span>
                    </div>

                    <div className="popup-section">
                        <strong>Solicitante:</strong> <span>{chamado.solicitanteNome}</span>
                    </div>
                    <div className="popup-section">
                        <strong>Setor:</strong> <span>{chamado.solicitanteSetor || '-'}</span>
                    </div>

                    <div className="popup-section">
                        <strong>E-mail:</strong> <span>{chamado.solicitanteEmail}</span>
                    </div>
                    <div className="popup-section">
                        <strong>WhatsApp:</strong> <span>{chamado.solicitanteWhatsApp || '-'}</span>
                    </div>
                </div>

                {/* INFO ESPECÍFICA: CRIAÇÃO DE USUÁRIO */}
                {chamado.dadosNovoUsuario && (
                    <div className="popup-section full-width" style={{ backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '6px', border: '1px solid #eee', marginTop: '10px' }}>
                        <strong style={{ display: 'block', marginBottom: '8px', color: '#00897b' }}>📋 Dados para Novo Usuário:</strong>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', fontSize: '13px' }}>
                            <div><strong>Nome:</strong> {chamado.dadosNovoUsuario.nome}</div>
                            <div><strong>Email:</strong> {chamado.dadosNovoUsuario.email}</div>
                            <div><strong>Trocar Senha?</strong> {chamado.dadosNovoUsuario.forcePasswordChange ? 'Sim' : 'Não'}</div>
                            <div style={{ gridColumn: 'span 2' }}>
                                <strong>Permissões:</strong>
                                <ul style={{ margin: '5px 0 0 20px', padding: 0 }}>
                                    {Object.entries(chamado.dadosNovoUsuario.permissions || {}).map(([key, val]) => (
                                        (val.view || val.edit) && (
                                            <li key={key}>
                                                {key}: {val.view ? 'Ver' : ''} {val.edit ? '/ Editar' : ''}
                                            </li>
                                        )
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                )}

                <div className="popup-section full-width" style={{ marginTop: '15px' }}>
                    <strong>Descrição do Problema / Solicitação:</strong>
                    <div className="description-box" style={{ minHeight: '80px', backgroundColor: '#fff' }}>
                        {chamado.descricao || "Nenhuma descrição informada."}
                    </div>
                </div>

                <hr className="popup-divider" />

                <div className="popup-actions-row">
                    {/* ALTERAR URGÊNCIA */}
                    <div className="popup-section">
                        <strong>Urgência:</strong>
                        <select
                            className={`text-input ${getPriorityClass(chamado.priority)}`}
                            value={chamado.priority}
                            onChange={(e) => alterarUrgencia(chamado, e.target.value)}
                        >
                            <option>Baixa</option>
                            <option>Média</option>
                            <option>Alta</option>
                            <option>Crítico</option>
                        </select>
                    </div>

                    {/* ALTERAR RESPONSÁVEL */}
                    <div className="popup-section">
                        <strong>Responsável:</strong>
                        <select
                            className="text-input"
                            value={chamado.assignedToName || "Sem Responsável"}
                            onChange={(e) => alterarResponsavel(chamado, e.target.value)}
                        >
                            {TECNICOS.map((t) => (
                                <option key={t}>{t}</option>
                            ))}
                        </select>
                    </div>

                    {/* ALTERAR STATUS */}
                    <div className="popup-section">
                        <strong>Status:</strong>
                        <select
                            className={`text-input ${getStatusClass(chamado.status)}`}
                            value={chamado.status}
                            onChange={(e) => alterarStatus(chamado, e.target.value)}
                        >
                            <option>Aberto</option>
                            <option>Em Andamento</option>
                            <option>Pendente de Retorno</option>
                            <option>Concluído</option>
                        </select>
                    </div>
                </div>

                <div className="popup-dates">
                    <small>Abertura: {formatDate(chamado.createdAt)}</small>
                    <small> • Início: {formatDate(chamado.startedAt)}</small>
                    <small> • Conclusão: {formatDate(chamado.closedAt)}</small>
                </div>

            </div>
        </div>,
        document.body
    );
}

/* =====================================================
            POPUP DE CHAT
===================================================== */
function PopupChat({ chamado, onClose }) {
    if (!chamado) return null;

    return createPortal(
        <div className="popup-overlay">
            <div className="popup-chat">
                <button className="popup-close" onClick={onClose}>X</button>
                <h2>Chat - #{chamado.idPublico}</h2>

                <ChatWindow
                    chamadoId={chamado.id}
                    isTecnico={true}
                    solicitanteNome={chamado.solicitanteNome}
                    assignedToName={chamado.assignedToName}
                />

            </div>
        </div>,
        document.body
    );
}


/* =====================================================
            COMPONENTE PRINCIPAL
===================================================== */
function PainelChamados() {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [loadingAuth, setLoadingAuth] = useState(true);
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((u) => {
            setUser(u);
            setLoadingAuth(false);
        });
        return unsubscribe;
    }, []);

    /* ESTADOS */
    const [chamadosAtivos, setChamadosAtivos] = useState([]);
    const [chamadosConcluidos, setChamadosConcluidos] = useState([]);

    // UI States
    const [loadingData, setLoadingData] = useState(true);
    const [popupDetalhes, setPopupDetalhes] = useState(null);
    const [popupChat, setPopupChat] = useState(null);

    /* FILTROS LOCAIS (Ainda úteis para busca rápida na lista carregada) */
    const [filtroTexto, setFiltroTexto] = useState("");
    const [filtroResponsavel, setFiltroResponsavel] = useState("todos");

    /* =========================================================
       BUSCAR CHAMADOS - Estratégia Otimizada (Split Query)
       ========================================================= */
    useEffect(() => {
        if (!user) return;

        const chamadosRef = collection(db, getCollectionName("chamados"));

        // Um único listener busca tudo e divide no cliente — evita conflito interno do Firestore SDK
        // quando dois listeners têm queries sobrepostas na mesma coleção.
        const qAll = query(chamadosRef, orderBy("createdAt", "desc"), limit(150));

        const unsub = onSnapshot(qAll, (snap) => {
            const lista = snap.docs.map(normalizarChamado);
            const ATIVOS = ["Aberto", "Em Andamento", "Pendente de Retorno"];
            setChamadosAtivos(lista.filter(c => ATIVOS.includes(c.status)));
            setChamadosConcluidos(lista.filter(c => c.status === "Concluído").slice(0, 50));
            setLoadingData(false);
        }, (err) => console.error("Erro chamados:", err));

        return () => unsub();
    }, [user]);

    // Helper para formatar dados firebase
    const normalizarChamado = (doc) => {
        const data = doc.data();
        return {
            id: doc.id,
            ...data,
            title: data.title || data.titulo || "Sem Título",
            descricao: data.descricao || data.description || "",
            createdAt: data.createdAt || null,
            idPublico: data.idPublico || doc.id.substring(0, 5).toUpperCase(),
            solicitanteNome: data.solicitanteNome || "Usuário",
        };
    };


    /* AÇÕES DE UPDATE */
    const updateTicket = async (id, data) => {
        try {
            await updateDoc(doc(db, getCollectionName("chamados"), id), data);
        } catch (error) {
            console.error("Erro ao atualizar:", error);
            alert("Erro ao atualizar chamado. Tente novamente.");
        }
    };

    const mudarResponsavel = (c, novo) => {
        updateTicket(c.id, { assignedToName: novo === "Sem Responsável" ? null : novo });
    };

    const mudarUrgencia = (c, nova) => {
        updateTicket(c.id, { priority: nova });
    };

    const mudarStatus = (c, novo) => {
        const update = { status: novo };
        // Lógica de timestamps
        if (novo === "Em Andamento" && !c.startedAt) update.startedAt = serverTimestamp();
        if (novo === "Concluído") update.closedAt = serverTimestamp();
        if (c.status === "Concluído" && novo !== "Concluído") update.closedAt = null;

        updateTicket(c.id, update);
    };


    /* FILTRAGEM LOCAL DE EXIBIÇÃO */
    const filtrarLista = (lista) => {
        return lista.filter(c => {
            // Filtro Texto (busca geral em ID, Título, Solicitante)
            if (filtroTexto) {
                const term = filtroTexto.toLowerCase();
                const match =
                    String(c.idPublico).toLowerCase().includes(term) ||
                    (c.title || "").toLowerCase().includes(term) ||
                    (c.solicitanteNome || "").toLowerCase().includes(term);
                if (!match) return false;
            }
            // Filtro Responsável
            if (filtroResponsavel !== "todos") {
                const resp = c.assignedToName || "Sem Responsável";
                if (resp !== filtroResponsavel) return false;
            }
            return true;
        });
    };

    const ativosVisiveis = filtrarLista(chamadosAtivos);
    const concluidosVisiveis = filtrarLista(chamadosConcluidos);

    // KPIs Rápidos
    const kpis = {
        abertos: chamadosAtivos.filter(c => c.status === 'Aberto').length,
        andamento: chamadosAtivos.filter(c => c.status !== 'Aberto').length,
        concluidos: chamadosConcluidos.length // (Limitado pelo query, é mais um 'recentes')
    };

    if (loadingAuth || (loadingData && !user)) {
        return <div className="loading-screen">Carregando sistema...</div>;
    }

    if (!user) {
        navigate("/login");
        return null;
    }

    return (
        <div className="chamados-main">
            {/* HEADER */}
            {/* HEADER */}
            <div className="page-header" style={{ marginBottom: '20px' }}>
                <h2 style={{ color: '#555', margin: 0 }}>Central de Atendimento</h2>
            </div>

            {/* CARDS KPI */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
                {[
                    {
                        label: 'Abertos',
                        value: kpis.abertos,
                        icon: '🚀',
                        color: '#ef4444',
                        bg: '#fef2f2',
                        border: '#fecaca',
                        sub: `${chamadosAtivos.filter(c => c.priority === 'Crítico').length} crítico(s)`,
                    },
                    {
                        label: 'Em Andamento',
                        value: kpis.andamento,
                        icon: '⚙️',
                        color: '#f59e0b',
                        bg: '#fffbeb',
                        border: '#fde68a',
                        sub: `${chamadosAtivos.filter(c => c.status === 'Pendente de Retorno').length} aguardando retorno`,
                    },
                    {
                        label: 'Concluídos (recentes)',
                        value: kpis.concluidos,
                        icon: '✅',
                        color: '#10b981',
                        bg: '#ecfdf5',
                        border: '#a7f3d0',
                        sub: 'últimos 50',
                    },
                    {
                        label: 'Total na Fila',
                        value: chamadosAtivos.length,
                        icon: '📋',
                        color: '#3b82f6',
                        bg: '#eff6ff',
                        border: '#bfdbfe',
                        sub: `${chamadosAtivos.filter(c => !c.assignedToName).length} sem responsável`,
                    },
                ].map(card => (
                    <div key={card.label} style={{
                        background: card.bg,
                        border: `1px solid ${card.border}`,
                        borderRadius: '14px',
                        padding: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '6px',
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <span style={{ fontSize: '24px' }}>{card.icon}</span>
                            <span style={{
                                fontSize: '36px', fontWeight: 800, color: card.color, lineHeight: 1,
                            }}>{card.value}</span>
                        </div>
                        <div style={{ fontSize: '13px', fontWeight: 700, color: '#374151' }}>{card.label}</div>
                        <div style={{ fontSize: '11px', color: '#9ca3af' }}>{card.sub}</div>
                    </div>
                ))}
            </div>

            {/* BARRA DE FILTROS */}
            <div className="control-bar" style={{ marginBottom: '16px' }}>
                <div className="filter-group">
                    <input
                        className="search-input"
                        placeholder="Buscar ID, Título, Nome..."
                        value={filtroTexto}
                        onChange={(e) => setFiltroTexto(e.target.value)}
                    />

                    <select
                        className="filter-select"
                        value={filtroResponsavel}
                        onChange={(e) => setFiltroResponsavel(e.target.value)}
                    >
                        <option value="todos">Todos Técnicos</option>
                        {TECNICOS.map((t) => (<option key={t}>{t}</option>))}
                    </select>
                </div>
            </div>

            {/* TABELA ATIVOS */}
            <div className="section-header">
                <h2>🔥 Fila de Atendimento</h2>
            </div>

            <div className="table-container">
                <table className="tabela-chamados">
                    <thead>
                        <tr>
                            <th style={{ width: '60px' }}>ID</th>
                            <th>Solicitação</th>
                            <th>Quem Pediu</th>
                            <th>Responsável</th>
                            <th style={{ width: '100px' }}>Urgência</th>
                            <th style={{ width: '120px' }}>Status</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ativosVisiveis.length === 0 ? (
                            <tr><td colSpan="7" className="empty-row">Nenhum chamado ativo na fila.</td></tr>
                        ) : (
                            ativosVisiveis.map((c) => (
                                <tr key={c.id} className={`row-priority-${c.priority?.toLowerCase()}`}>
                                    <td className="id-cell">#{c.idPublico}</td>
                                    <td>
                                        <div className="cell-title" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                            {c.title}
                                            {c.lastMessageBy === 'solicitante' && (
                                                <span className="msg-badge msg-badge-solicitante" title="Nova mensagem do solicitante">
                                                    💬 Nova Msg
                                                </span>
                                            )}
                                        </div>
                                        <div className="cell-subtitle">{formatDate(c.createdAt)}</div>
                                    </td>
                                    <td>{c.solicitanteNome}</td>
                                    <td>
                                        <select
                                            className="compact-select"
                                            value={c.assignedToName || "Sem Responsável"}
                                            onChange={(e) => mudarResponsavel(c, e.target.value)}
                                        >
                                            {TECNICOS.map((t) => (<option key={t}>{t}</option>))}
                                        </select>
                                    </td>
                                    <td>
                                        <select
                                            className={`compact-select ${getPriorityClass(c.priority)}`}
                                            value={c.priority}
                                            onChange={(e) => mudarUrgencia(c, e.target.value)}
                                        >
                                            <option>Baixa</option><option>Média</option><option>Alta</option><option>Crítico</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select
                                            className={`compact-select ${getStatusClass(c.status)}`}
                                            value={c.status}
                                            onChange={(e) => mudarStatus(c, e.target.value)}
                                        >
                                            <option>Aberto</option>
                                            <option>Em Andamento</option>
                                            <option>Pendente de Retorno</option>
                                            <option>Concluído</option>
                                        </select>
                                    </td>
                                    <td>
                                        <div className="action-buttons">
                                            <button className="btn-icon" title="Ver Detalhes" onClick={() => setPopupDetalhes(c)}>👁️</button>
                                            <button className="btn-icon" title="Abrir Chat" onClick={() => setPopupChat(c)}>💬</button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* TABELA CONCLUÍDOS */}
            <div className="section-header" style={{ marginTop: '40px' }}>
                <h2>✅ Últimos Concluídos</h2>
                <small>(Exibindo os últimos 50)</small>
            </div>

            <div className="table-container">
                <table className="tabela-chamados clogged">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Título</th>
                            <th>Solicitante</th>
                            <th>Técnico</th>
                            <th>Conclusão</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {concluidosVisiveis.length === 0 ? (
                            <tr><td colSpan="6" className="empty-row">Nenhum histórico recente.</td></tr>
                        ) : (
                            concluidosVisiveis.map((c) => (
                                <tr key={c.id} className="row-done">
                                    <td>#{c.idPublico}</td>
                                    <td>{c.title}</td>
                                    <td>{c.solicitanteNome}</td>
                                    <td>{c.assignedToName || "-"}</td>
                                    <td>{formatDate(c.closedAt || c.createdAt)}</td>
                                    <td>
                                        <button className="btn-sm" onClick={() => setPopupDetalhes(c)}>Reabrir/Ver</button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* POPUPS */}
            {popupDetalhes && (
                <PopupDetalhes
                    chamado={popupDetalhes}
                    onClose={() => setPopupDetalhes(null)}
                    alterarResponsavel={mudarResponsavel}
                    alterarStatus={mudarStatus}
                    alterarUrgencia={mudarUrgencia}
                />
            )}

            {popupChat && (
                <PopupChat
                    chamado={popupChat}
                    onClose={() => setPopupChat(null)}
                />
            )}
        </div>
    );
}

export default PainelChamados;